module.exports = __webpack_public_path__ + "static/media/noa_tote_back.e0af949c.jpg";